import { CONTENT_ROOT_ID } from '../hooks/useContentScroll';

export function scrollToTop(behavior: ScrollBehavior = 'smooth') {
  document.getElementById(CONTENT_ROOT_ID)?.scrollTo({ top: 0, behavior });
}

export function scrollIntoView(
  id: string,
  { behavior = 'smooth', block }: { behavior?: ScrollBehavior; block?: ScrollLogicalPosition },
) {
  document.getElementById(id)?.scrollIntoView({ behavior, block });
}
